export function BrandMark() {
  return (
    <svg className="brand__mark" viewBox="0 0 40 40" aria-hidden="true">
      <rect x="4" y="7" width="32" height="27" rx="7" />
      <path d="M4 18c3-2.5 5-2.5 8 0s5 2.5 8 0 5-2.5 8 0 5 2.5 8 0" />
      <circle cx="26" cy="27" r="1.6" fill="currentColor" stroke="none" />
      <circle cx="29.5" cy="23" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function Brand() {
  return (
    <a className="brand" href="/" aria-label="Aquarium Helpline home">
      <BrandMark />
      <span className="brand__words">
        Aquarium <em>Helpline</em>
      </span>
    </a>
  );
}
